import { Link } from 'react-router-dom';
import { categories } from '@/mocks/siteData';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 lg:px-10 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-user-star-line text-background-50 text-base"></i>
              </div>
              <span className="font-heading text-xl text-background-50">
                真人网站精选
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              专注真人网站定义、分类与筛选标准的内容导航平台，帮助用户快速找到优质真人网站资源，是发现可信真人网站的一站式参考指南。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-background-50 text-base mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer whitespace-nowrap">首页</Link></li>
              <li><Link to="/category" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer whitespace-nowrap">分类浏览</Link></li>
              <li><Link to="/about" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer whitespace-nowrap">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-background-50 text-base mb-4">热门分类</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category?tab=${cat.slug}`}
                    className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-background-50 text-base mb-4">联系方式</h4>
            <ul className="space-y-2.5 text-sm text-background-400">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-base"></i>
                <span>contact@zhenrensite.cn</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-base"></i>
                <span>400-888-9999</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-base"></i>
                <span>北京市朝阳区</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-500">
            &copy; {currentYear} 真人网站精选推荐. 保留所有权利.
          </p>
          <div className="flex items-center gap-4 text-sm text-background-500">
            <a href="#" className="hover:text-background-300 transition-colors cursor-pointer whitespace-nowrap">隐私政策</a>
            <a href="#" className="hover:text-background-300 transition-colors cursor-pointer whitespace-nowrap">用户协议</a>
            <a href="#" className="hover:text-background-300 transition-colors cursor-pointer whitespace-nowrap">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}